import React from 'react';

export default props => {
    return (    
        <svg width={props.width || '15px'} height={props.height || '11px'} viewBox="0 0 15 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="bestill-fag" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Fag-utlisting-Copy-18" transform="translate(-1408.000000, -1938.000000)" stroke={props.color || '#AAAAAA'} strokeWidth="3">
                    <g id="Group" transform="translate(1408.000000, 1938.000000)">
                        <path d="M14.5,5.5 L0,5.5" id="Line-3-Copy"></path>
                        <path d="M5.5,0 L5.5,11" id="Line-3" strokeOpacity="0.01"></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/images/MinifyIcon.js